/**
 * Sidebar Navigation Component
 * Handles scroll-to functionality for content sections based on sidebar clicks
 */

function initSidebarNavigation() {
    const tocItems = document.querySelectorAll('.toc-item');
    const mobileTocItems = document.querySelectorAll('.mobile-toc-item');

    if (!tocItems.length && !mobileTocItems.length) {
        return;
    }

    // Show all sections
    document.querySelectorAll('.content-section').forEach(section => {
        section.style.display = 'block';
    });

    // Function to handle TOC item clicks - scroll to section (same page only)
    function handleTocClick(isMobile) {
        return function(e) {
            const href = this.getAttribute('href') || '';
            if (!href.startsWith('#')) {
                return;
            }
            e.preventDefault();

            const targetId = href.substring(1);
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
                // Update active states
                tocItems.forEach(link => link.classList.remove('active'));
                mobileTocItems.forEach(link => link.classList.remove('active'));
                this.classList.add('active');

                // Sync active state
                const selector = isMobile ? '.toc-item' : '.mobile-toc-item';
                const corresponding = document.querySelector(`${selector}[href="${href}"]`);
                if (corresponding) corresponding.classList.add('active');

                // Scroll to section
                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };
    }

    // Attach click handlers
    tocItems.forEach(item => {
        item.addEventListener('click', handleTocClick(false));
    });

    mobileTocItems.forEach(item => {
        item.addEventListener('click', handleTocClick(true));
    });

    // Highlight active section on scroll (top-level legal sections only — not nested blocks inside privacy)
    const sections = document.querySelectorAll('.content-area > .content-section');

    function updateActiveOnScroll() {
        const contentArea = document.querySelector('.content-area');
        const scrollTop = contentArea ? contentArea.scrollTop : window.scrollY;

        let currentSection = '';
        sections.forEach(section => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 200) {
                currentSection = section.id;
            }
        });

        if (currentSection) {
            const href = '#' + currentSection;
            tocItems.forEach(item => {
                item.classList.toggle('active', item.getAttribute('href') === href);
            });
            mobileTocItems.forEach(item => {
                item.classList.toggle('active', item.getAttribute('href') === href);
            });
        }
    }

    const contentArea = document.querySelector('.content-area');
    if (contentArea) {
        contentArea.addEventListener('scroll', updateActiveOnScroll);
    }
    window.addEventListener('scroll', updateActiveOnScroll);

    // Handle URL hash on load (scroll + match TOC active state)
    const hash = window.location.hash;
    if (hash) {
        const target = document.getElementById(hash.substring(1));
        if (target) {
            setTimeout(() => {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                tocItems.forEach(item => {
                    item.classList.toggle('active', item.getAttribute('href') === hash);
                });
                mobileTocItems.forEach(item => {
                    item.classList.toggle('active', item.getAttribute('href') === hash);
                });
            }, 100);
        }
    }
}

// Expose to global for concatenated builds
window.initSidebarNavigation = initSidebarNavigation;
